/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

const e={name:"@lexical/react/ReactProvider"};export{e as ReactProviderExtension};
